// src/components/common/MetricsUI.jsx

export function DeltaChip({
  delta,
  isPercent = false,
  unit = "",
  decimals,
  label = "vs prev.",
  invertTrendColors = false,
}) {
  const eps = isPercent ? 0.001 : 0.005;

  const trend = !Number.isFinite(delta)
    ? "flat"
    : delta > eps
    ? "up"
    : delta < -eps
    ? "down"
    : "flat";

  const absVal = Number.isFinite(delta)
    ? Math.abs(delta) * (isPercent ? 100 : 1)
    : 0;

  const dps = Number.isInteger(decimals)
    ? decimals
    : isPercent
    ? 1
    : 2;

  const sign =
    trend === "up" ? "+" : trend === "down" ? "−" : "";

  const text = `${sign}${absVal.toFixed(dps)}${
    isPercent ? "%" : unit
  }`;

  const positiveIsGood = !invertTrendColors;
  const cls =
    trend === "up"
      ? positiveIsGood
        ? "bg-white/95 dark:bg-gray-900/95 text-emerald-600 ring-1 ring-emerald-400 dark:text-emerald-300 dark:ring-emerald-600/70"
        : "bg-white/95 dark:bg-gray-900/95 text-rose-600 ring-1 ring-rose-400 dark:text-rose-300 dark:ring-rose-600/70"
      : trend === "down"
      ? positiveIsGood
        ? "bg-white/95 dark:bg-gray-900/95 text-rose-600 ring-1 ring-rose-400 dark:text-rose-300 dark:ring-rose-600/70"
        : "bg-white/95 dark:bg-gray-900/95 text-emerald-600 ring-1 ring-emerald-400 dark:text-emerald-300 dark:ring-emerald-600/70"
      : "bg-white/95 dark:bg-gray-900/95 text-gray-700 ring-1 ring-gray-300 dark:text-gray-200 dark:ring-gray-600/70";

  const icon =
    trend === "up" ? "▲" : trend === "down" ? "▼" : "=";

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium backdrop-blur ${cls}`}
      title={`Δ ${label}`}
    >
      <span aria-hidden>{icon}</span>
      <span>{text}</span>
    </span>
  );
}

export function Kpi({
  title,
  value,
  big,
  delta,
  isPercent = false,
  unit = "",
  decimals,
}) {
  const trendColor = !Number.isFinite(delta)
    ? "text-inherit"
    : delta > 0
    ? "text-emerald-600 dark:text-emerald-400"
    : delta < 0
    ? "text-rose-600 dark:text-rose-300"
    : "text-gray-800 dark:text-gray-200";

  return (
    <div className="rounded-xl border p-3 md:p-4 text-center bg-white/90 dark:bg-gray-900/90 border-gray-200 dark:border-gray-700 shadow-sm">
      <div className="text-xs opacity-70 text-gray-700 dark:text-gray-300">
        {title}
      </div>
      <div
        className={`font-semibold ${
          big ? "text-2xl mt-1" : "text-lg"
        } ${trendColor}`}
      >
        {value}
      </div>
      <div className="mt-1 flex justify-center">
        <DeltaChip
          delta={delta}
          isPercent={isPercent}
          unit={unit}
          decimals={decimals}
        />
      </div>
    </div>
  );
}
